import { Field, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { TemplateScope } from './TemplateScope'
import { BaseEntity } from '../base/BaseEntity'

@ObjectType()
export class Template extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  description: string

  @Field(() => String)
  @Prop({ type: String })
  value: string

  @Field(() => String)
  @Prop({ type: String })
  category: string

  @Field(() => Boolean)
  @Prop({ type: Boolean })
  isDefault: boolean

  @Field(() => TemplateScope)
  @Prop({ type: TemplateScope })
  scope: TemplateScope

  @Field(() => String)
  @Prop({ type: String })
  filter: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  filterTemplateId?: string

  @Field(() => Boolean, { nullable: true })
  @Prop({ type: Boolean })
  autoApplyFilterTemplate?: boolean
}
